<template>
  <v-app theme="light">
    <header-nav></header-nav>
    <v-content>
      <v-container fluid>
        <transition>
          <router-view></router-view>
        </transition>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import headerNav from '@/core/header/header'

export default {
  name: 'App',
  components: {
    headerNav
  }
}
</script>

<style lang="scss">
@import url('https://unpkg.com/vuetify@1.3.9/dist/vuetify.min.css');
@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Material+Icons');
@import url('https://fonts.googleapis.com/css?family=Exo+2:400,100,200,300,700,500,600,800,100italic,200italic,300italic,400italic,500italic,600italic,700italic,800italic');

* {
  font-family: 'Exo 2', sans-serif;
}

.application.theme---light {
  background-color: #f6f7f9;
}
</style>
